module.exports = __webpack_public_path__ + "img/phone-call.e2de69bc.svg";